// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1873) return "static/chunks/1873-abc8fc5684f12bf6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1331":"dbdc8979d8fc7592","1514":"e0994b815eba63c1","1748":"4cd5247113169904","5497":"a182dd670dcc26fc","6235":"079a727c70e87360","7126":"1eda73005eff8fef"}[chunkId] + ".js";
};